import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getSession} from 'actions/index';

export const detectAuth = WrappedComponent => {
  class AuthDetector extends Component {
    componentWillMount() {
      const {location: {pathname}, dispatch} = this.props
      dispatch(getSession(pathname));
    }
    render() {
      return (
        <div id="wrapper__detect-auth">
          <WrappedComponent {...this.props} />
        </div>
      );
    }
  }

  return connect()(AuthDetector);
};

export const requireAuth = WrappedComponent => {
  const mstp = state => ({session: state.login.session});

  class AuthResolver extends Component {
    render() {
      return (
        <div id="wrapper__require-auth">
          {this.props.session ?
            <WrappedComponent {...this.props} />
           : <span>{/* Resolving Auth...*/}</span>
          }
        </div>
      );
    }
  }

  return detectAuth(connect(mstp)(AuthResolver));
};



// WEBPACK FOOTER //
// ./src/utils/authorization.js